import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  FaBars, FaTimes, FaHome, FaBoxOpen, 
  FaPhone, FaSignInAlt, FaTruck
} from 'react-icons/fa';

const ClientHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Scroll эффект
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Route өөрчлөгдөхөд mobile menu хаах
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  // Body overflow-г удирдах
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isMobileMenuOpen]);

  // Scroll to section
  const scrollToSection = (sectionId) => {
    // Хэрэв нүүр хуудас дээр биш бол эхлээд нүүр хуудас руу очоод scroll хий
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  const scrollToTop = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

    // 🆕 АЧАА ДУУДЛАГА хэсэг рүү scroll хийх
  const scrollToCargoRequest = () => {
    scrollToSection('cta'); // CTA хэсэг рүү очно
  };

  // Нэвтрэх хуудас шинэ tab-д нээх
  const openLoginPage = () => {
    window.open('/login', '_blank');
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { 
      path: '/', 
      label: 'Нүүр хуудас', 
      icon: <FaHome />,
      action: scrollToTop
    },
    { 
      path: '#services', 
      label: 'Үйлчилгээ', 
      icon: <FaTruck />,
      action: () => scrollToSection('services')
    },
    { 
      path: '#cargo-request', 
      label: 'Ачаа дуудлага', 
      icon: <FaBoxOpen />,
      action: scrollToCargoRequest
    },
    { 
      path: '#contact', 
      label: 'Холбоо барих', 
      icon: <FaPhone />,
      action: () => scrollToSection('contact')
    }
  ];

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return false; // Hash links-д active class хэрэггүй
  };

  return (
    <>
      <header className={`client-header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="header-container">
          {/* LOGO */}
          <Link 
            to="/" 
            className="header-logo"
            onClick={(e) => {
              if (location.pathname === '/') {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
          >
            <img 
              src="/logo.png" 
              alt="Жимгүн Карго" 
              className="logo-image"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextElementSibling.style.display = 'flex';
              }}
            />
            <div className="logo-fallback" style={{ display: 'none' }}>
              🚛
            </div>
            <div className="logo-text">
              <span className="logo-title">ЖИМ-ГҮН КАРГО</span>
            </div>
          </Link>

          {/* DESKTOP NAVIGATION */}
          <nav className="desktop-nav">
            <ul className="nav-list">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <button
                    onClick={link.action}
                    className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
                  >
                    <span className="nav-icon">{link.icon}</span>
                    <span>{link.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          {/* НЭВТРЭХ ТОВЧ + MOBILE TOGGLE */}
          <div className="header-actions">
            {/* 🆕 НЭВТРЭХ товч (Шинэ tab-д нээнэ) */}
            <button
              onClick={openLoginPage}
              className="login-btn"
              title="Нэвтрэх"
            >
              <FaSignInAlt className="login-icon" />
              <span className="login-text">Нэвтрэх</span>
            </button>

            {/* Mobile menu toggle */}
            <button
              className="mobile-menu-toggle"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Menu"
            >
              {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
      </header>

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <div 
          className="mobile-menu-overlay" 
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
        <div className="mobile-menu-content">
          <div className="mobile-menu-header">
            <div className="mobile-menu-logo">
              <img 
                src="/logo.png" 
                alt="Жимгүн Карго" 
                className="w-12 h-12"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextElementSibling.style.display = 'block';
                }}
              />
              <div className="text-4xl hidden">🚛</div>
            </div>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="mobile-menu-close"
            >
              <FaTimes />
            </button>
          </div>

          <nav className="mobile-nav">
            <ul className="mobile-nav-list">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <button
                    onClick={link.action}
                    className={`mobile-nav-link ${isActive(link.path) ? 'active' : ''}`}
                  >
                    <span className="mobile-nav-icon">{link.icon}</span>
                    <span>{link.label}</span>
                  </button>
                </li>
              ))}
              
              {/* Mobile-д Нэвтрэх товч */}
              <li className="mobile-login-divider">
                <button
                  onClick={openLoginPage}
                  className="mobile-nav-link login-mobile-link"
                >
                  <span className="mobile-nav-icon"><FaSignInAlt /></span>
                  <span>Нэвтрэх</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
};

export default ClientHeader;